
import NavigationColumns from "./footer/NavigationColumns";
import SocialLinks from "./footer/SocialLinks";
import LegalSection from "./footer/LegalSection";

const Footer = () => {
  return (
    <footer className="bg-racing-dark border-t border-white/10 w-full">
      <div className="container mx-auto px-4 py-12">
        <NavigationColumns />
        <SocialLinks />
        <LegalSection />
      </div>
    </footer>
  );
};

export default Footer;
